import {useTooltipContext} from '../hooks/useTooltipContext'

export const useBarChartTooltipContext = () => {
  return useTooltipContext<{key?: string}>()
}
